// extracted by mini-css-extract-plugin
module.exports = {"list":"validation-error-list_list__4I8ZF","listItem":"validation-error-list_listItem__q0n9p"};